import { render, staticRenderFns } from "./randomExamination.vue?vue&type=template&id=65ae02d4"
import script from "./randomExamination.vue?vue&type=script&lang=js"
export * from "./randomExamination.vue?vue&type=script&lang=js"
import style0 from "./randomExamination.vue?vue&type=style&index=0&id=65ae02d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports